import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-related-blog',
    templateUrl: './related-blog.component.html',
    styleUrls: ['./related-blog.component.scss']
})
export class RelatedBlogComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {}

}